import { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import axios from "axios";
import Share from "../ShareEmaileFax/Share";
import MainPageDialog from "../dialog";
import { Loader } from "../loader";
import { useShareEfaxMutation } from "../../services/procedureService";
import { getFileUrl } from "../../helper";

export const PrintProcedures = ({
  selectedChat,
  printData,
  setShowPrintShareView,
  printLink,
  title,
  userUniqueId = {},
  completeUrl = "", //when we are passing full URL for iframee
  hideFooterBtn = true,
  faxShow = true,
}) => {
  const pdfUrl = getFileUrl(printData?.uuid);
  const [showShareeFax, setShowShareeFax] = useState(false);
  const [loadingShare, setLoadingShare] = useState(false);
  const {
    practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  // const { authToken } = useSelector(
  //   ({ auth }) => ({
  //     authToken: auth && auth.authToken,
  //   }),
  //   shallowEqual
  // );
  // const { practice_id } = useSelector(
  //   ({ auth }) => ({
  //     practice_id: auth.practice_id,
  //   }),
  //   shallowEqual
  // );
  const [shareEfax] = useShareEfaxMutation();
  const printIframe = () => {
    let fileUrl =
      completeUrl != ""
        ? completeUrl
        : `${process.env.REACT_APP_API_URL_V1}/${printLink}=${
            printData?.uuid
          }&token=${authToken}&tz=${new Date().getTimezoneOffset()}&practice_id=${practice_id}`;
    window.open(fileUrl, "_blank", "noreferrer");
  };

  const footerList = [
    {
      title: "Cancel",
      type: "cancel",
      action: () => setShowPrintShareView(false),
    },
    hideFooterBtn && {
      title: "Print",
      type: "save",
      action: () => printIframe(),
    },
    hideFooterBtn && {
      title: "Email/Fax",
      type: "save",
      action: () => setShowShareeFax(true),
    },
  ];

  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    if (completeUrl) {
      setIsLoading(true);
    }
    axios.get(completeUrl).then((response) => {
      setIsLoading(false);
    });
  }, []);
  let html = `<iframe id="printDiv" width="100%" height="1100" scrolling="auto" frameborder="1" allow="autoplay" src=${
    completeUrl != "" ? completeUrl : pdfUrl
  }></iframe>`;
  return (
    <div>
      <MainPageDialog
        title={title || "Procedures"}
        onCancelHandler={() => setShowPrintShareView(false)}
        footer={true}
        footerList={footerList}
      >
        {(isLoading || loadingShare) && (
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[99]">
            {" "}
            <Loader />
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </MainPageDialog>
      {showShareeFax && (
        <Share
          from={"procedure"}
          userUniqueId={userUniqueId}
          setShowPrintShareView={setShowPrintShareView}
          printData={printData}
          shareApi={shareEfax}
          setShowShareeFax={setShowShareeFax}
          setLoadingShare={setLoadingShare}
          faxShow={faxShow}
          sharePreviewUrl={printLink}
          title={title}
        />
      )}
    </div>
  );
};
